import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { recordedBattleDuration } from '../../../util/iosSlotPlayback';
import { battleCaption, battleActorName } from '../../../features/Fight/battleCaption';
import { CDNImage } from '../../Elements/Image';

/** Plays the recorded battle without allocating another WebGL renderer or sprite atlases. */
export function IOSSlotPlayback({ fight, onFinish }: { fight: any; onFinish: () => void }) {
  const { t } = useTranslation();
  const [elapsed, setElapsed] = React.useState(0);
  const finish = React.useRef(onFinish); finish.current = onFinish;
  const duration = recordedBattleDuration(fight);
  React.useEffect(() => {
    let done = false;
    const started = performance.now();
    const tick = () => {
      const time = Math.min(duration, performance.now() - started);
      setElapsed(time);
      if (!done && time >= duration) { done = true; window.clearInterval(timer); finish.current(); }
    };
    const timer = window.setInterval(tick, 100);
    return () => { done = true; window.clearInterval(timer); };
  }, [fight, duration]);
  const turns = Array.isArray(fight.fight) ? fight.fight : [];
  const turn = turns.reduce((last: any, next: any) => Number.isFinite(next.time) && next.time * 10 <= elapsed ? next : last, null);
  const caption = turn ? battleCaption(turn, (key, options) => String(t(key, options))) : '';
  const text = caption;
  return <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(#102b3c, #213a2c)', color: '#fff5d5', padding: 35, boxSizing: 'border-box' }}>
    <h2 style={{ textAlign: 'center' }}>{Number(fight.scene) === 2 ? 'การต่อสู้สนามประลอง' : 'การต่อสู้สล็อต'}</h2>
    <p style={{ textAlign: 'center' }}>โหมดภาพเบาสำหรับ iOS</p>
    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', minHeight: 230 }}>
      {[true, false].map(side => <div key={String(side)} style={{ display: 'flex', gap: 18, flexWrap: 'wrap', justifyContent: 'center', width: '42%' }}>
        {(fight.roles ?? []).filter((role: any) => !!role.isOnOffense === side).map((role: any) => <div key={role.index} style={{ textAlign: 'center', width: 100 }}>
          <CDNImage src={`icons/people/${role.avatar}.png`} style={{ width: 68, height: 68, objectFit: 'contain' }} />
          <div>{battleActorName(role, (key, options) => String(t(key, options)))}</div>
        </div>)}
      </div>)}
    </div>
    <div role="status" style={{ textAlign: 'center', minHeight: 40 }}>{text || 'กำลังต่อสู้…'}</div>
    <progress aria-label="ความคืบหน้าการต่อสู้" value={elapsed} max={duration} style={{ width: '100%', height: 18 }} />
    <p style={{ textAlign: 'center' }}>จบแล้วจะแสดงผลการต่อสู้ตามปกติ</p>
  </div>;
}
